import { AddressesUrlParams } from "../parameters/addresses-url-params";

export let MENU_ITEM = {
  "Donaciones Covid-19": {
    title: "Donaciones Covid-19"
  }  
};



// WEBPACK FOOTER //
// ./src/app/pages/menu.ts